module.exports = __webpack_public_path__ + "img/16805e2.jpg";